import { useLocation } from 'react-router';
export default function useHasReactRouterContext() {
    try {
        useLocation();
        return true;
    }
    catch (_a) {
        return false;
    }
}
